import { Check, Copy, Pencil, RotateCcw, Download } from "lucide-react";

export const MessageActions = ({
  msgId,
  msgText,
  copiedId,
  onCopy,
  onTryAgain,
  onEdit,
  onDownload,
  downloadTitle = "Download",
  hideCopy = false,
  showTryAgain = false,
  alwaysVisible = false,
}) => {
  return (
    <div className={`flex flex-row gap-1 transition-opacity ${alwaysVisible ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`}>
      {!hideCopy && (
        <button
          onClick={() => onCopy(msgId, msgText)}
          title="Copy"
          className="p-2 rounded-xl text-slate-400 hover:text-[#1d57a5] transition-colors"
        >
          {copiedId === msgId ? (
            <Check size={16} className="text-[#36a852]" />
          ) : (
            <Copy size={16} />
          )}
        </button>
      )}
      {showTryAgain && onTryAgain && (
        <button
          onClick={() => onTryAgain(msgId)}
          title="Try Again"
          className="p-2 rounded-xl text-slate-400 hover:text-[#36a852] transition-colors"
        >
          <RotateCcw size={16} />
        </button>
      )}
      {/* {onEdit && (
        <button
          onClick={() => onEdit(msgId, msgText)}
          title="Edit"
          className="p-2 bg-white dark:bg-slate-700 rounded-xl shadow-sm hover:bg-slate-50 dark:hover:bg-slate-600 border border-slate-100 dark:border-slate-600 text-slate-400 hover:text-[#1d57a5] transition-colors"
        >
          <Pencil size={16} />
        </button>
      )} */}
      {onDownload && (
        <button
          onClick={onDownload}
          title={downloadTitle}
          className="p-2 rounded-xl text-slate-400 hover:text-[#1d57a5] transition-colors"
        >
          <Download size={16} />
        </button>
      )}
      {/* <button
        onClick={() => onTryAgain(msgId)}
        title="Try Again"
        className="p-2 bg-white dark:bg-slate-700 rounded-xl shadow-sm hover:bg-slate-50 dark:hover:bg-slate-600 border border-slate-100 dark:border-slate-600 text-slate-400 hover:text-[#36a852] transition-colors"
      >
        <RotateCcw size={16} />
      </button> */}
    </div>
  );
};
